var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reject"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6719 10.9817C12.6719 11.2197 12.5867 11.4499 12.4318 11.6306L10.0433 14.4172C9.83014 14.6659 9.47504 14.7376 9.18204 14.5911C8.89597 14.4481 8.75861 14.1165 8.85975 13.813L9.68059 11.3505L7.38548 11.3505C7.32566 11.3505 7.26597 11.3452 7.20712 11.3345C6.66532 11.2359 6.30596 10.7169 6.40447 10.1751L7.03898 6.68523C7.12519 6.21112 7.53812 5.8665 8.02 5.8665L11.6748 5.8665C12.2255 5.8665 12.6719 6.31292 12.6719 6.8636L12.6719 10.9817Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.666 6.36512L14.666 10.8521",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2336",
    cx: 10.2667,
    cy: 10.2667,
    r: 9.66667,
    stroke: "black",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/Rejected_icon.f7b5013826286fbc03a8646a5544ac01.svg";
export { ForwardRef as ReactComponent };